import { Button } from '@mui/material'
import Link from 'next/link'
import Icon from '@mui/material/Icon'
import makeStyles from '@mui/styles/makeStyles'
import * as gtag from 'lib/gtag'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  }
}))

export function MoreShowsButton ({ series }) {
  const classes = useStyles()

  const encodedSeries = encodeURIComponent(series)

  const logEvent = () => {
    gtag.event('alle_anzeigen')
  }

  const url = `/search?q="${encodedSeries}"`
  return (
    (
      <div className={classes.root}>
        <Link href={url} passHref prefetch={false} legacyBehavior>
          <Button
            variant='outlined'
            startIcon={<Icon>add</Icon>}
            className='btn-more-shows'
            id='btn-more-shows'
            onClick={logEvent}
          >
            Mehr anzeigen
          </Button>
        </Link>
      </div>
    )
  )
}
